import cn from 'clsx'
import React from 'react'
import Button from 'components/ui/button'
import Icon from 'components/ui/icon'
import Tooltip from 'components/ui/tooltip'
import styles from './index.module.css'

const DRAG_HANDLE_ICON = (
  <svg width="10" height="16">
    <path
      fill="currentcolor"
      d="M4 14c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    />
  </svg>
)
const MAX_LENGTH = 255
type Props = {
  name: string
  onBlur?: (event: React.SyntheticEvent<HTMLInputElement>) => void
  onChange?: (event: React.SyntheticEvent<HTMLInputElement>) => void
  onClick?: () => void
  onFocus?: () => void
  onRemove?: () => void
}
const ShortlistSection = React.forwardRef<HTMLInputElement, Props>(
  (
    { name, onBlur, onChange, onClick, onFocus, onRemove }: Props,
    ref: React.Ref<HTMLInputElement>,
  ) => {
    const hasError: boolean = name.length > MAX_LENGTH
    return (
      <div className={styles.shortlistSection}>
        <div className={styles.shortlistSectionDragHandle}>
          {DRAG_HANDLE_ICON}
        </div>
        <div
          className={cn(styles.shortlistSectionContent, {
            [styles.shortlistSectionContentError]: hasError,
          })}
          onClick={onClick}
        >
          <input
            className={styles.shortlistSectionInput}
            readOnly={onChange ? false : true}
            ref={ref}
            type="text"
            value={name}
            onBlur={onBlur}
            onChange={onChange}
            onFocus={onFocus}
          />
          <div className={styles.shortlistSectionActions}>
            {onRemove && (
              <div className={styles.shortlistSectionRemove}>
                <Tooltip content="Remove from shortlist">
                  <Button
                    appearance="icon"
                    compact
                    icon="clear"
                    onClick={onRemove}
                  />
                </Tooltip>
              </div>
            )}
            {hasError && (
              <div className={styles.shortlistSectionErrorIcon}>
                <Tooltip content="Sorry! That section title is too long.">
                  <Icon type="info" width={16} height={16} />
                </Tooltip>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  },
)
export default React.memo(ShortlistSection) as React.MemoExoticComponent<
  React.ForwardRefExoticComponent<
    Props & React.RefAttributes<HTMLInputElement | null | undefined>
  >
>
